import React from 'react';
import { ApolloProvider } from '@apollo/client';

import config from './config';
import { client } from './services/Graph';
import { AuthProvider } from './context/AuthContext';
import { FeatureProvider } from './providers/FeatureProvider';
import Routes from './routes/Routes';

import 'mapbox-gl/dist/mapbox-gl.css';
import ModalProvider from './providers/ModalProvider';
import { BrowserRouter as Router } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

function App() {
  const stripePromise = loadStripe(config.stripe.publishableKey);

  return (
    <ApolloProvider client={client}>
      <FeatureProvider>
        <Router>
          <ModalProvider>
            <AuthProvider>
              <Elements stripe={stripePromise}>
                <Routes />
              </Elements>
            </AuthProvider>
          </ModalProvider>
        </Router>
      </FeatureProvider>
    </ApolloProvider>
  );
}

export default App;
